// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  inviteKey: __t.string().primaryKey().name("invite_key"),
  roomId: __t.u64().name("room_id"),
  invitee: __t.identity(),
  invitedBy: __t.identity().name("invited_by"),
  at: __t.timestamp(),
});
